import * as React from 'react'

/**
 * @description IdentityCard icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { IdentityCard } from '@sravni/design-system-icons'
 *
 * <IdentityCard />
 * ```
 */
export const IdentityCard = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="IdentityCard" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.68 6.8a1.875 1.875 0 1 1-2.652 2.65A1.875 1.875 0 0 1 8.679 6.8Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.937 15.417v-10.8c0-.939.761-1.7 1.7-1.7h13.3c.92 0 1.666.746 1.666 1.666v10.834c0 .92-.746 1.666-1.667 1.666H3.603c-.92 0-1.666-.745-1.666-1.666ZM12.77 7.917h3.333M14.77 11.25h-2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.35 13.75a2.641 2.641 0 0 0-2.458-1.667H6.815a2.643 2.643 0 0 0-2.458 1.667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
